var _style, _path, _path2, _path3, _path4, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ff6868}.st1{fill:#858186}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.2 22.3h-3c-.3 0-.5-.2-.6-.5l-.7-3.5c0-.2 0-.4.1-.5s.3-.2.5-.2H28c.2 0 .4.1.5.2s.2.3.1.5l-.7 3.5c-.1.3-.4.5-.7.5zm-2.4-1.2h2l.5-2.3h-3l.5 2.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.2 35c-.1 0-.3-.1-.4-.1-.1-.1-.2-.3-.2-.5v-1.8c0-.7-.6-1.3-1.3-1.3h-7.2c-.1 0-.4 0-.6-.2l-6.1-5.4-3.4-.3c-.2 0-.3.2-.4.1-.1-.1-.2-.3-.2-.5.5-4.3 4.1-7.5 8.4-7.5h9.7c2.3 0 4.4.9 6 2.5s2.5 3.7 2.5 6v6.2c0 .2-.1.4-.3.5-.6.3-1.2.7-1.9 1-.8.4-1.7.7-2.9 1-.8.1-1.1.3-1.7.3zm-8.8-4.8h7c1.4 0 2.5 1.1 2.5 2.5v1.1c.3-.1.7-.1 1-.2 1-.2 1.9-.5 2.6-.9.5-.3 1-.6 1.5-.8V26c0-1.9-.8-3.8-2.1-5.1-1.4-1.4-3.2-2.1-5.1-2.1h-9.7c-3.5 0-6.4 2.5-7.1 5.8h2.9c.1 0 .3 0 .4.1l6.1 5.5zm15.1 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.9 34.5c-.3 0-.6-.3-.6-.6v-6.7c0-.3.3-.6.6-.6s.6.3.6.6v6.7c0 .4-.3.6-.6.6zM25.8 16.4c-3.7 0-6.8-3-6.8-6.8 0-3.7 3-6.8 6.8-6.8 3.7 0 6.8 3 6.8 6.8-.1 3.8-3.1 6.8-6.8 6.8zm0-12.3c-3.1 0-5.6 2.5-5.6 5.6s2.5 5.6 5.6 5.6 5.6-2.5 5.6-5.6c-.1-3.1-2.6-5.6-5.6-5.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m28 30.6-4.6.1c-.2 0-.3.5-.4.4-.1-.1-.2-.2-.2-.4l.9-9.1c0-.3.3-.5.6-.5h3c.3 0 .6.2.6.5l.9 9.1c0 .2 0 .3-.2.5-.1.1-.4-.6-.6-.6zm-4-.4h3.4l-.8-7.9h-1.9l-.7 7.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7 45.2H.6c-.3 0-.6-.3-.6-.6V21.9c0-.3.3-.6.6-.6H7c.3 0 .6.3.6.6v22.7c0 .3-.2.6-.6.6zM1.3 44h5.1V22.5H1.2V44h.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.2 43.1c-3.8 0-7-1.5-9.5-2.7-1.2-.6-2.2-1-3-1.2-2.5-.6-5.7-.6-5.7-.6-.3 0-.6-.3-.6-.6V25.1c0-.3.3-.6.6-.6l9.9.1c.4.1.4.3 1.2 1l5.2 4.5h7c1.4 0 2.5 1.1 2.5 2.5v1.1c.3-.1.7-.1 1-.2 1-.2 1.9-.5 2.6-.9.6-.3 1.3-.7 1.8-1 .6-.3 1.1-.6 1.6-.9 3.4-2 6-3.6 7.8-1.1.5.7.6 1.4.4 2.1-.6 2.6-4.6 5.1-8.8 7.5-5.1 3-8.6 3.9-14 3.9zM7.6 37.4c1.1 0 3.4.1 5.4.6.9.2 2 .7 3.2 1.3 2.4 1.2 5.4 2.6 9 2.6 5.1 0 8.5-.9 13.4-3.7 2.7-1.6 7.7-4.4 8.2-6.7.1-.4 0-.8-.3-1.2-1.1-1.5-2.8-.6-6.2 1.4-.5.3-1 .6-1.6.9-.6.3-1.2.7-1.9 1-.8.4-1.7.7-2.9 1-.6.1-1.3.3-1.8.3-.2 0-.3 0-.5-.1-.1-.1-.2-.3-.2-.5v-1.8c0-.7-.6-1.3-1.3-1.3h-7.2c-.1 0-.3-.1-.4-.1l-5.3-4.7c-.6-.5-1.3-.8-2.1-.8H7.5v11.8h.1zm31.3 1.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.8 35.4c-4.5 0-8.6-.5-8.9-.6-.3 0-.6-.3-.5-.7 0-.3.3-.6.7-.5.1 0 8.1 1.1 14 .2.3 0 .6.2.7.5 0 .3-.2.6-.5.7-1.8.3-3.7.4-5.5.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.eabc4c0f0f55f63e5158cb813ccf0737.svg";
export { ForwardRef as ReactComponent };